import React, { useMemo } from 'react';
import RichTextEditor from '../ui/RichTextEditor';
import {
  canonicalCampaignEmailHtml,
  htmlFromCampaignEmailEditor,
} from '../../utils/campaignEmailTemplate';

/**
 * Éditeur campagne : la variable %hubup_notification_button% reste visible dans le texte
 * (Quill supprime les faux boutons HTML). Le rendu bouton = aperçu à droite + à l’envoi.
 */
export default function CampaignEmailRichTextEditor({
  value,
  onChange,
  minEditorHeight = 160,
  className = '',
}) {
  const displayValue = useMemo(
    () => canonicalCampaignEmailHtml(value),
    [value],
  );

  const handleChange = (editorHtml) => {
    onChange(htmlFromCampaignEmailEditor(editorHtml));
  };

  return (
    <RichTextEditor
      value={displayValue}
      onChange={handleChange}
      minEditorHeight={minEditorHeight}
      className={className}
    />
  );
}
